import { _ as __assign } from './chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import ChannelSettingsUI from './ChannelSettings/components/ChannelSettingsUI.js';
import { ChannelSettingsProvider } from './ChannelSettings/context.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './ChannelSettings/components/ChannelSettingsHeader.js';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './ui/Icon.js';
import './chunks/bundle-kFa80LJe.js';
import './ui/Header.js';
import './chunks/bundle-CjJk57u5.js';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './ui/IconButton.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './ChannelSettings/components/ChannelProfile.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './chunks/bundle-BlguTwHI.js';
import './ChannelSettings/components/EditDetailsModal.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import './chunks/bundle-DP3z2QNm.js';
import 'react-dom';
import './ui/Button.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './ui/Input.js';
import './ChannelSettings/components/LeaveChannel.js';
import './ChannelSettings/components/ChannelSettingsMenuItem.js';
import './ChannelSettings/components/ChannelSettingMenuList.js';
import './chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import './ChannelSettings/hooks/useMenuList.js';
import './chunks/bundle-D9B0ru2u.js';
import './chunks/bundle-CsqTBO6B.js';
import './ui/UserListItem.js';
import './chunks/bundle-DXFVroy5.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './chunks/bundle-mqagBpi9.js';
import './chunks/bundle-CzHaD4PM.js';
import './chunks/bundle-BjAeG049.js';
import './chunks/bundle-DUYVf7yy.js';
import './ui/Badge.js';
import './ui/Toggle.js';
import './chunks/bundle-DXKWyDSR.js';

var ChannelSettings = function (props) {
    return (React__default.createElement(ChannelSettingsProvider, __assign({}, props),
        React__default.createElement(ChannelSettingsUI, __assign({}, props))));
};

export { ChannelSettings as default };
//# sourceMappingURL=ChannelSettings.js.map
